<template>
  <div class="header">
    <div class="row container between">
      <div class="row" />
      <p class="em">Welcome, {{ username }}</p>
    </div>
    <div class="search-container">
      <div>
        <label>Search:</label>
        <input
          type="text"
          class="main-search-field no-close"
          placeholder="search invoices, business name or customer"
          :value="fieldVal"
          v-on:input="updateFieldVal"
          @focus="activateSearch"
        />
        <button class="red clear-btn no-close" :class="{active: hasSearchContent}" @click="clearButtonClick">x</button>
        <button class="green submit-btn" @click="searchButtonClick" :disabled="!fieldVal || fieldVal.length < 3">Submit</button>

        <!-- Search field area -->
        <div class="recent-searches no-close" v-if="searchActive">
          <div class="row between no-close">
            <p class='no-close'>Recent searches</p>
            <button @click="closeSearch" class='red circle'>x</button>
          </div>
          <ul class="recent-terms no-close" v-if="recentTerms.length > 0">
            <li
              v-for="term in recentTerms"
              :key="term"
              @click="() => setValue(term)"
              class='search-term no-close'
            >
              {{ term }}
            </li>
          </ul>
          <div v-else class='container pt-5 no-close'>No recent searches</div>
          <p class='no-close'>Quick results</p>
          <div class="recent-results">
            <div v-for="(res, index) in quickResults" :key="index" @click="() => clickAndSearch(res)">
              <div class="result-img">
                <font-awesome-icon icon='file-invoice' />
              </div>
              <div class="result-info">
                <div class="t-left strong">{{ res.business }}</div>
                <div>{{ res.phone }}</div>
                <div>{{ res.orderdated }}</div>
                <div class="t-left">{{ res.firstname }} {{ res.lastname }}</div>
                <div>{{ res.email }}</div>
                <div>{{ res.number }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- Search field area -->
      </div>
    </div>
  </div>
</template>

<script>
import router from '../router/'
import { filterObjectValues } from '../utils/filter'
export default {
  name: "MainHeader",
  data: () => ({
    fieldVal: "",
    searchActive: false
  }),
  computed: {
    hasSearchContent(){ return this.fieldVal !== '' },
    recentTerms() {
      const terms = this.$store.getters.recentSearches;
      return [...terms]
        .filter(t => {
          return t.toLowerCase().includes(this.fieldVal.toLowerCase());
        })
        .splice(0, 15);
    },
    username() {
      return this.$store.getters.user.username || "";
    },
    quickResults() {
      const masterList = [...this.$store.getters.invoiceList, ...this.$store.getters.compiledSearchResults]
      let addedInvoices = []
      let allList = []
      masterList.map(inv => {
        if(!addedInvoices.includes(inv.invoice)){
          addedInvoices.push(inv.invoice)
          allList.push(inv)
        }
      })
      return filterObjectValues(allList, this.fieldVal, 6)
    }
  },
  destroyed (){
    this.closeSearch()
  },
  methods: {
    clearButtonClick(){
      this.fieldVal = ''
    },
    checkClick(e){
      if(!e.target.classList.contains('no-close') && this.searchActive){
        this.searchActive = false
      }
    },
    searchButtonClick(){
      this.closeSearch()
      const useFieldVal = encodeURIComponent(this.fieldVal.replace(/\//g, '').replace(/\./, '').replace(/#/g, ''))
      if(this.$route.fullPath === '/'){
        router.push('/search/search/' + useFieldVal)
      } else {
        router.push('/')
          .then(() => router.push('/search/search/' + useFieldVal))
      }
    },
    activateSearch() {
      document.addEventListener('click', this.checkClick)
      document.addEventListener('keypress', this.enterSearch)
      this.searchActive = true;
    },
    enterSearch(e){
      if(e.keyCode === 13 && !(!this.fieldVal || this.fieldVal.length < 3)) {
        this.searchButtonClick()
      }
    },
    clickAndSearch(res){
      if(res.business && res.business !== '') this.fieldVal = res.business
      else if(res.email && res.email !== '') this.fieldVal = res.email
      else if(res.number && res.number !== '') this.fieldVal = res.number
      else this.fieldVal = res.invoice
      this.searchButtonClick()
    },
    closeSearch() {
      document.removeEventListener('keypress', this.enterSearch)
      document.removeEventListener('click', this.checkClick)
      this.searchActive = false;
    },
    updateFieldVal(e) {
      this.fieldVal = e.target.value;
    },
    setValue(term) {
      this.fieldVal = term;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/colors.scss";
@import "../styles/vars.scss";
.header {
  background-color: $maroon;
  height: $header-height;
  color: #fff;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - #{$side-bar-width});
  margin-left: $side-bar-width;
  .search-container {
    position: relative;
    width: 100%;
    transition: width 0.3s;
    padding-bottom: 15px;
    & > div {
      position: relative;
      background-color: #fff;
      padding: 4px 0 4px 10px;
      width: 95%;
      border-radius: 5px;
      margin: 0 auto;
      color: rgb(160, 160, 160);
      & > * {
        margin: 0;
      }
      input[type="text"] {
        width: calc(100% - 183px);
        color: #666;
      }
      label {
        width: 80px;
        color: rgb(77, 77, 77);
      }
      .submit-btn {
        width: 80px;
        padding: 10px;
      }
      .clear-btn{
        opacity: 0;
        background-color: #fff;
        padding: 0;
        margin: 0;
        margin-right: 7px;
        font-size: 1.5rem;
        color: $red;
        position: relative; 
        top: 3px;
        border-radius: 50%;
        width: 20px;
        &:hover{
          color: #000;
        }
        &.active {
          opacity: 1;
        }
      }
      .red.circle {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        font-size: 1.2rem;
      }
    }
  }
  .recent-searches {
    max-height: calc(100vh - #{$header-height});
    overflow: auto;
    position: absolute;
    width: 100%;
    z-index: 5;
    background-color: #fff;
    left: 0;
    top: 50px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    & p {
      margin-bottom: 5px;
      padding: 5px 20px;
      color: $darkBlue;
    }
    .recent-terms {
      width: 100%;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;
      font-weight: normal;
      li {
        padding: 8px 20px;
        &:hover {
          color: $lightBlue;
          cursor: pointer;
        }
      }
    }
  }
  .recent-results {
    width: 96%;
    margin: 0 auto;
    margin-top: 12px;
    padding-bottom: 20px;
    cursor: pointer;
    & > div {
      transition: all .2s;
      display: flex;
      margin-bottom: 13px;
      padding: 10px;
      border-radius: 5px;
      .result-img {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        margin-right: 17px;
        background-color: $darkBlue;
        border: 4px solid $lightBlue;
        color: $lightBlue;
        font-size: 1.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .result-info {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        font-weight: normal;
        width: calc(100% - 60px);
        div {
          margin-top: 5px;
          margin-bottom: 5px;
          text-align: right;
          width: 30%;
          &.long {
            width: 50%;
          }
          &.t-left {
            text-align: left;
          }
        }
      }
      &:hover{
        background-color: #ececec;
        color: #333;
      }
    }
  }
}
.mobileView .header {
  width: 100%;
  margin-left: 0;
}
</style>
